// All user related database operations can be defined here.

import {
  GET_FORMS,
  GET_FORM,
  START_RESPONSE,
  RECORD_ANSWER,
  RECORD_ANSWERS,
  GET_INVITEE_FORMS,
  GET_TAKER,
  GET_INFO,
  GET_CONFIG,
  EVALUATE_MEDICAL_MONITORING,
  REQUEST_MEDICAL_MONITORING_RETAKE
} from "./CONSTANTS";
import http from "../http-common";
import { IAnswerModel } from "../slices/forms-reducer";

class FormsDataService {
  getForms() {
    return http.get(GET_FORMS);
  }
  getInviteeForms(relativeId: number) {
    return http.get(GET_INVITEE_FORMS(relativeId));
  }
  getForm(formId: string) {
    return http.get(GET_FORM(formId));
  }
  startResponse(formVersionId: string, startResponseModel: IStartResponseRequestModel) {
    return http.post(START_RESPONSE(formVersionId), startResponseModel);
  }
  recordAnswer(formVersionId: string, responseId: string, answer: IAnswerModel) {
    return http.post(RECORD_ANSWER(formVersionId, responseId), answer)
  }
  
  recordAnswers(formVersionId: string, responseId: string, model: IRecordAnswersRequestModel) {
    return http.post(RECORD_ANSWERS(formVersionId, responseId), model)
  }

  getUser(inviteeId: number) {
    return http.get(GET_TAKER(inviteeId))
  }

  getInfo() {
    return http.get(GET_INFO)
  }

  getConfig() {
    return http.get(GET_CONFIG)
  }

  evaluateMedicalMonitoring(model: IMedicalMonitoringReadings) {
    return http.post<IMedicalMonitoringEvaluation>(EVALUATE_MEDICAL_MONITORING, model)
  }

  /** Keyed off the response just submitted; 404s if the patient has no repeat outstanding. */
  requestMedicalMonitoringRetake(responseId: string) {
    return http.post<IMedicalMonitoringRetake>(REQUEST_MEDICAL_MONITORING_RETAKE(responseId), {})
  }
}

export interface IMedicalMonitoringReadings {
  systolic?: number | null;
  diastolic?: number | null;
  pulse?: number | null;
  responseId?: string;
}

export interface IMedicalMonitoringEvaluation {
  inRange: boolean;
  outOfRange: string[];
  /** True when these readings are the second set for the cycle. */
  isRepeat: boolean;
}

export interface IMedicalMonitoringRetake {
  responseId: string;
}

export interface IStartResponseRequestModel {
  formVersionId: string,
  formResponseId?: string;
}

export interface IRecordAnswersRequestModel {
  pageNumber :number,
  answers: IAnswerModel[];
}

const dataservice = new FormsDataService();

export default dataservice;
